import { useCallback } from 'react';
import Button from 'src/components/design-system/Button';
import PopUp from 'src/components/design-system/PopUp';
import Layout from 'src/components/Layout';
import Navbar from 'src/components/NavBar';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import useCheckbookConfiguration from 'src/hooks/useCheckbookConfiguration';
import useGuideMe from 'src/hooks/useGuideMe';
import { GLCodeGuideMeSteps } from './GuideMeContent';

const CheckbookConfigurationNavBar = () => {
  const {
    pageTitle,
    t,
    isCheckbookConfigPageDirty,
    setAreFormatsRequired,
    setGlCodeFormats,
    initialGlFormats,
    glFormatsResponse,
    areFormatsRequired,
    checkForInvalidGLCodesAndSave,
    saveWithToaster,
    isSaveDisable,
    saveErrorMessage,
    isPageEditable,
    hasWarnings,
    warningList,
    isGettingInvalidGLCodes,
    areGLMasksLoading,
    isSavingGLFormats,
  } = useCheckbookConfiguration();
  const { guideMe } = useGuideMe({
    steps: GLCodeGuideMeSteps(true),
    guideId: 'checkbook-configuration',
  });

  const handleSave = useCallback(async () => {
    if (areFormatsRequired) {
      checkForInvalidGLCodesAndSave();
    } else {
      saveWithToaster();
    }
  }, [areFormatsRequired, checkForInvalidGLCodesAndSave, saveWithToaster]);

  const handleCancel = useCallback(() => {
    setGlCodeFormats(initialGlFormats);
    setAreFormatsRequired(glFormatsResponse?.setGlMask);
  }, [glFormatsResponse?.setGlMask, initialGlFormats, setAreFormatsRequired, setGlCodeFormats]);

  return (
    <>
      <Navbar title={pageTitle} />
      <Layout>
        <header className="flex justify-between items-center flex-wrap min-h-[56px]">
          <div className="flex flex-grow items-center justify-end">
            {isPageEditable && (
              <PopUp
                popupAlign={{ horizontal: 'center', vertical: 'top' }}
                content={
                  <div className="m-1 max-w-[350px]">
                    <PopUpContentWrapper type={'Error'} contents={saveErrorMessage} />
                    <PopUpContentWrapper type={'Warning'} contents={warningList} />
                  </div>
                }
                show={(isSaveDisable && saveErrorMessage.length > 0) || hasWarnings}
              >
                <Button
                  color="primary"
                  disabled={
                    isSaveDisable ||
                    areGLMasksLoading ||
                    isGettingInvalidGLCodes ||
                    isSavingGLFormats
                  }
                  onClick={handleSave}
                >
                  {t('Save')}
                </Button>
              </PopUp>
            )}
          </div>
          <div
            className={`flex flex-grow items-center ${
              isPageEditable ? 'justify-between' : 'justify-end'
            }`}
          >
            {isPageEditable && (
              <Button color="error" onClick={handleCancel} disabled={!isCheckbookConfigPageDirty}>
                {t('Cancel')}
              </Button>
            )}
            {areFormatsRequired ? guideMe : ''}
          </div>
        </header>
      </Layout>
    </>
  );
};

export default CheckbookConfigurationNavBar;
